import styled from 'styled-components';
import { textColor, THEME_MUTED } from '../../../styles/basics/colors';
import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const StyledCoverImg = styled.img`
    max-width: 100%;
    height: auto;
`;

StyledCoverImg.displayName = 'LCProductDetailAssetCover__StyledCoverImg';

const StyledPlaceholderText = styled.p`
    font-size: 15px;
    ${textColor(THEME_MUTED)};
`;

interface Props {
    coverUrl: string;
    productTitle: string;
}

export const LCProductDetailAssetCover: FC<Props> = ({ coverUrl, productTitle }) => {
    const { t } = useTranslation();
    const coverImageRef = useRef<HTMLImageElement>(null);
    if (coverUrl) {
        return <StyledCoverImg src={coverUrl} ref={coverImageRef} alt={productTitle} />;
    } else {
        return <StyledPlaceholderText>{t('yourLocalContent.yourTitles.warnings.noCoverAdded')}</StyledPlaceholderText>;
    }
};
